import React, { RefObject } from 'react';
import { formatCampaignType } from '@/utils/formatEnum';
import { BackToCampaignsLink } from './BackToCampaignsLink';

interface CampaignHeaderProps {
  campaignName: string;
  campaignType: string | undefined;
  campaignNameRef: RefObject<HTMLHeadingElement | null>;
}

/**
 * Campaign page header with back link, title, and campaign type badge.
 */
export function CampaignHeader({
  campaignName,
  campaignType,
  campaignNameRef,
}: CampaignHeaderProps) {
  return (
    <div className="mb-6">
      {/* Mobile: Back link and badge on same row */}
      <div className="flex items-center justify-between mb-2 md:mb-4">
        <BackToCampaignsLink />
        {/* Badge shown here on mobile, hidden on md+ */}
        {campaignType && (
          <span className="md:hidden px-3 py-1 rounded-md text-sm font-medium bg-gray-100 text-gray-800">
            {formatCampaignType(campaignType)}
          </span>
        )}
      </div>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h1
            ref={campaignNameRef}
            className="text-2xl md:text-3xl font-bold text-gray-900"
          >
            {campaignName}
          </h1>
        </div>
        {/* Badge shown here on md+, hidden on mobile */}
        {campaignType && (
          <span className="hidden md:inline-block px-3 py-1 rounded-md text-sm font-medium bg-gray-100 text-gray-800">
            {formatCampaignType(campaignType)}
          </span>
        )}
      </div>
    </div>
  );
}
